import { useMemo } from "react";
import { hasRichText } from "./richText";
import { linkifyHtml, splitTextByUrl } from "./linkify";

interface NotesDisplayProps {
  value: string | null | undefined;
  className?: string;
}

/**
 * Renders notes content, supporting both legacy plain-text strings and
 * Quill-produced HTML. HTML is only rendered for values that clearly look
 * like rich text; plain strings fall back to text nodes. In both cases bare
 * URLs are turned into clickable links.
 */
export function NotesDisplay({ value, className }: NotesDisplayProps) {
  const rich = value ? hasRichText(value) : false;
  const html = useMemo(() => (value && rich ? linkifyHtml(value) : null), [value, rich]);

  if (!value) return null;
  const cls = `notes-display ${className ?? ""}`.trim();

  if (rich && html != null) {
    return <div className={cls} dangerouslySetInnerHTML={{ __html: html }} />;
  }

  return (
    <div className={cls}>
      {splitTextByUrl(value).map((seg, idx) =>
        seg.href ? (
          <a key={idx} href={seg.href} target="_blank" rel="noopener noreferrer nofollow">
            {seg.text}
          </a>
        ) : (
          <span key={idx}>{seg.text}</span>
        ),
      )}
    </div>
  );
}
